export default "__VITE_ASSET__c7719f69__"